export default __webpack_public_path__ + "static/media/1003.780ea066.png";